<template>
  <div>
    <section class="xbed-sub-title">
      <span>月度结算详情</span>
    </section>
    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>报表</BreadcrumbItem>
        <BreadcrumbItem>月度结算汇总</BreadcrumbItem>
        <BreadcrumbItem>月度结算详情</BreadcrumbItem>
      </Breadcrumb>
    </section>
    <div>
      <Row style="marginTop:15px">
        <Col span="4">结账月份：{{lastAllSettle.settleDate ? lastAllSettle.settleDate : '-'}}</Col>
        <Col span="4">结算状态：{{lastAllSettle.settlementStatus ? lastAllSettle.settlementStatus : '-'}}</Col>
      </Row>
      <Row style="marginTop:20px">
        <Col span="4">房间：{{lastAllSettle.roomName ? lastAllSettle.roomName : '-'}}</Col>
        <Col span="4">门店：{{lastAllSettle.chainName ? lastAllSettle.chainName : '-'}}</Col>
        <Col span="4">业主：{{lastAllSettle.ownerName ? lastAllSettle.ownerName : '-'}}</Col>
      </Row>
      <Row style="marginTop:20px" class="selt-p">
        <Col span="3" class="selt-col">
          <p>总结算金额</p>
          <p>{{lastAllSettle.settlementPriceSum ? (lastAllSettle.settlementPriceSum/100).toFixed(2) : '0'}}</p>
        </Col>
        <Col span="3" class="selt-col">
          <p>结算房费</p>
          <p>{{lastAllSettle.roomChargeSettlementPrice ? (lastAllSettle.roomChargeSettlementPrice/100).toFixed(2) : '0'}}</p>
        </Col>
        <Col span="3" class="selt-col">
          <p>结算非房费收入</p>
          <p>{{lastAllSettle.noRoomChargeSettlementPrice ? (lastAllSettle.noRoomChargeSettlementPrice/100).toFixed(2) : '0'}}</p>
        </Col>
        <Col span="3" class="selt-col">
          <p>结算销售费用</p>
          <p>{{lastAllSettle.marketChargeSettlementPrice ? (lastAllSettle.marketChargeSettlementPrice/100).toFixed(2) : '0'}}</p>
        </Col>
        <Col span="3" class="selt-col">
          <p>结算维护费用</p>
          <p>{{lastAllSettle.maintainChargeSettlementPrice ? (lastAllSettle.maintainChargeSettlementPrice/100).toFixed(2) : '0'}}</p>
        </Col>
        <Col span="3" class="selt-col">
          <p>结算管理费用</p>
          <p>{{lastAllSettle.adminChargeSettlementPrice ? (lastAllSettle.adminChargeSettlementPrice/100).toFixed(2) : '0'}}</p>
        </Col>
      </Row>
      <Form @submit.native.prevent="preventSubmit" inline style="marginTop:20px">
        <FormItem label="经营日期:" prop="manageTime" :label-width="90">
          <DatePicker type='daterange' v-model="manageTime" placeholder="请选择时间" class="date-time" style="width: 230px"></DatePicker>
        </FormItem>
        <FormItem label="科目:" prop="subjectOne" :label-width="90">
          <Cascader :data="subjectData" change-on-select style="width:200px;" @on-change="handleSubject"></Cascader>
        </FormItem>
        <FormItem label="支付方式:" prop="playType" :label-width="90">
          <Select v-model="query.payType" style="width:280px;" multiple>
            <Option v-for="(item,index) in payArr" :value="item.dictValue" :key="index">{{ item.dictDesc }}</Option>
          </Select>
        </FormItem>
        <br>
        <FormItem label="预订来源:" prop="orderSource" :label-width="90">
          <Select v-model="query.orderSource" style="width:250px;" multiple>
            <Option v-for="(item,index) in sourceType" :key="index" :value='item.id'>{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="OTA单号:" prop="orderOTA" :label-width="90">
          <Input v-model="query.orderOTA" style="width:230px;"></Input>
        </FormItem>
        <FormItem label="订单号:" prop="orderNO" :label-width="90">
          <Input v-model="query.orderNO" style="width:230px;"></Input>
        </FormItem>
        <br>
        <FormItem label="工单号:" prop="jobNO" :label-width="90">
          <Input v-model="query.jobNO" style="width:230px;"></Input>
        </FormItem>
        <FormItem :label-width="20">
          <Button type="primary" @click="queryKeyWords">查询</Button>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="exportReport">导出筛选结果</Button>
        </FormItem>
      </Form>
      <Content>
        <Table :columns="columns" :data="accountList"></Table>
        <div style="margin: 10px;overflow: hidden">
          <Page show-sizer show-total placement="top" :current="query.page" :total="listTotal" :page-size="query.pageSize" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
        </div>
      </Content>
      <!-- 更新历史弹窗 -->
      <Modal v-model="updateModal.display" title="更新历史">
        <table class="tableData" cellspacing="0">
          <tr>
            <td>操作时间</td>
            <td>操作人</td>
            <td>更新内容</td>
          </tr>
          <tr v-if="updateModal.updateList.settlementTime">
            <td>{{updateModal.updateList.settlementTime}}</td>
            <td>-</td>
            <td>{{updateModal.updateList.settlementStatus}}</td>
          </tr>
          <tr v-if="updateModal.updateList.accountTime">
            <td>{{updateModal.updateList.accountTime}}</td>
            <td>-</td>
            <td>{{updateModal.updateList.accountStatus}}</td>
          </tr>
          <tr v-if="updateModal.updateList.ctime">
            <td>{{updateModal.updateList.ctime}}</td>
            <td>{{updateModal.updateList.creator}}</td>
            <td>创建</td>
          </tr>
        </table>
        <div slot="footer"></div>
      </Modal>
    </div>
  </div>
</template>

<script>
import Moment from "moment";
import Utils from "@/utils";
import API from "@/api";
import Config from "@/config";
export default {
  async created() {
    this.AuthorToken = Utils.findFromLocalStorage("Author-token");
    this.token = Utils.findFromLocalStorage( "vue-token" );
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.headerENV = Utils.aliHeaderEnv(this.env)
    this.settleDate = Utils.getUrlParameterByName("settleDate")
    this.ownerId = Utils.getUrlParameterByName("ownerId")
    this.roomId = Utils.getUrlParameterByName("roomId")
    this.owner = Utils.getUrlParameterByName("owner")
  },
  data () {
    return {
      manageTime:[],
      subjectData:[
        {
          value:0,
          label:'全部'
        }
      ],
      accountList:[],
      listTotal:0,
      payArr:[],
      sourceType:[],
      query:{
        subjectOne:0,
        subjectTwo:0,
        payType:[],
        orderSource:[],
        orderOTA:'',
        orderNO:'',
        jobNO:'',
        page:1,
        pageSize:10,
      },
      columns:[
        {
          title:'一级科目',
          key:'subjectName',
          align:'center',
          width:100,
          render:(h,params)=>{
            return h('div',{}, params.row.subjectName ? params.row.subjectName : '-')
          }
        },
        {
          title:'二级科目',
          key:'sonSubjectName',
          align:'center',
          width:150,
          render:(h,params)=>{
            return h('div',{}, params.row.sonSubjectName ? params.row.sonSubjectName : '-')
          }
        },
        {
          title:'经营日期',
          key:'accountDate',
          align:'center',
          width:150,
          render:(h,params)=>{
            let date = params.row.accountDate ? Moment(params.row.accountDate).format( 'YYYY-MM-DD' ):'-'
            return h('div',{},date)
          }
        },
        {
          title:'消费金额',
          key:'realPrice',
          align:'center',
          width:120,
          render:(h,params)=>{
            let realPrice = params.row.realPrice ? (params.row.realPrice/100).toFixed(2) : '0';
            return h('div',{},realPrice)
          }
        },
        {
          title:'结算金额',
          key:'settlementPrice',
          align:'center',
          width:120,
          render:(h,params)=>{
            let settlementPrice = params.row.settlementPrice ? (params.row.settlementPrice/100).toFixed(2) : '0';
            return h('div',{},settlementPrice)
          }
        },
        {
          title:'备注',
          key:'remark',
          align:'center',
          width:200,
          render:(h,params)=>{
            return h('p', {
              style: {
                maxHeight: '40px',
                color: '#495060',
                display: '-webkit-box',
                overflow: 'hidden',
                margin: '8px 0 7px',
                webkitLineClamp: '2',
                webkitBoxOrient: 'vertical',
                wordBreak: 'break-all'
              },
              attrs: {
                title: params.row.remark
              }
            },
            params.row.remark ? params.row.remark : '-')
          }
        },
        {
          title:'支付方式',
          key:'payType',
          align:'center',
          width:150,
          render:(h,params)=>{
            return h('div',{}, params.row.payType ? params.row.payType : '-')
          }
        },
        {
          title:'工单号',
          key:'cleanNo',
          align:'center',
          width:188,
          render:(h,params)=>{
            return h('div',{}, params.row.cleanNo ? params.row.cleanNo : '-')
          }
        },
        {
          title:'订单号',
          key:'orderNo',
          align:'center',
          width:230,
          render:(h,params)=>{
            return h('div',{}, params.row.orderNo ? params.row.orderNo : '-')
          }
        },
        {
          title:'入住单号',
          key:'checkId',
          align:'center',
          width:188,
          render:(h,params)=>{
            return h('div',{}, params.row.checkId ? params.row.checkId : '-')
          }
        },
        {
          title:'子入住单号',
          key:'checkinInfoId',
          align:'center',
          width:188,
          render:(h,params)=>{
            return h('div',{}, params.row.checkinInfoId ? params.row.checkinInfoId : '-')
          }
        },
        {
          title:'预订来源',
          key:'orderSource',
          align:'center',
          width:180,
          render:(h,params)=>{
            return h('div',{}, params.row.orderSource ? params.row.orderSource : '-')
          }
        },
        {
          title:'OTA单号',
          key:'otherNo',
          align:'center',
          width:210,
          render:(h,params)=>{
            return h('div',{}, params.row.otherNo ? params.row.otherNo : '-')
          }
        },
        {
          title:'最近更新(点击查看历史)',
          key:'operationLog',
          align:'center',
          width:200,
          render:(h,params)=>{
            return h('a',{
              on:{
                click:()=>{
                  this.updateModal.updateList = params.row
                  this.updateModal.display = true;
                }
              }
            }, params.row.operationLog ? params.row.operationLog : '-')
          }
        },
      ],
      // 更新历史弹窗
      updateModal:{
        display:false,
        updateList:{}
      },
      lastAllSettle:{}
    }
  },
  async mounted () {
    this.$Notice.config({
			top: 150
    });
    if ( !Utils.hasPermission( 'outConsumptions_settlementBillsReport' ) ) {
      this.$Notice.error( {
        title: "无权限操作"
      } );
      return
    }
    // 获取上个页面数据
    this.queryAllSettle()
    // 列表
    this.queryBillsReportData()
    // 科目
    this.getAllProject()
    // 支付方式
    this.getPayStyle()
    // 预订来源
    let orderSourceResp = ( await API.omsAPI[this.env].php.queryOrderSource()).data;
		if ( orderSourceResp.retdata instanceof Array ) {
			this.sourceType = orderSourceResp.retdata;
    }
  },
  methods: {
    // 获取上个页面数据
    async queryAllSettle(){
      let _queryParams = {
        settleDate:this.settleDate,
        ownerId:this.ownerId,
        roomId:this.roomId,
        pageNum: 1,
        pageSize: 10
      }
      const resp = (await API.omsAPI[this.env].clientServer.getSettlementMonthReport(_queryParams, {'x-ca-stage':this.headerENV, 'Authorization':this.AuthorToken, 'Right': this.token})).data;
      this.lastAllSettle = resp.list[0] || []
    },
    // 列表数据
    async queryBillsReportData(){
      let params = {
        pageNum:this.query.page,
        pageSize:this.query.pageSize,
        settleDate:this.settleDate,
        owner:this.owner.split('_')[1],
        roomId:this.roomId
      }
      this.query.subjectOne ? params.subjectId = this.query.subjectOne : ''
      this.query.subjectTwo ? params.sonSubjectId = this.query.subjectTwo : ''
      this.manageTime[0] ? (params.accountDateStart = Moment( this.manageTime[0] ).format( 'YYYY-MM-DD' )):''
      this.manageTime[1] ? (params.accountDateEnd = Moment( this.manageTime[1] ).format( 'YYYY-MM-DD' )):''
      this.query.payType.length !=0 ? (params.payTypes = this.query.payType.join(',')):''
      this.query.orderSource.length !=0 ? (params.orderSourceIds = this.query.orderSource.join(',')):''
      this.query.orderOTA ? ( params.otherNo = this.query.orderOTA):''
      this.query.orderNO ? (params.orderNo = this.query.orderNO):''
      this.query.jobNO ? (params.cleanNo = this.query.jobNO):''

      const resp = (await API.omsAPI[this.env].clientServer.getSettlementBillsReport(params, {'x-ca-stage':this.headerENV, 'Authorization':this.AuthorToken, 'Right': this.token})).data;
      if ( resp.retCode ) {
				this.$Notice.error( {
					title: resp.msg,
					desc: "获取列表数据失败"
				});
      }
      this.accountList = resp.list || []
      this.listTotal = resp.total
    },
    // 查询
    queryKeyWords(){
      this.query.page = 1
      this.queryBillsReportData()
    },
    // 分页
    changePage(page){
      this.query.page = page
      this.queryBillsReportData()
    },
    changePageSize(size){
      this.query.pageSize = size
      this.queryBillsReportData()
    },
    // 选择科目
    handleSubject(value, selectedData) {
      if (selectedData.length && selectedData[0].value) {
        this.query.subjectOne = selectedData[0].dictValue
        this.query.subjectTwo = selectedData.length === 2 ? selectedData[1].dictValue : 0
      } else {
        this.query.subjectOne = this.query.subjectTwo = 0
      }
    },
    // 科目
    async getProject(options){
      if (!options) {
        return
      }
      let _param = {
        pageNum: 1,
        pageSize: 9999, // 查询所有的一级科目
      }
      options.params = {...options.params, ..._param}
      const resp = (await API.omsAPI[this.env].clientServer.dictValueList(options.params, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
      if (resp.list && resp.list.length) {
        if (options.type === 3) {
          this.payArr = resp.list
        }
        resp.list.map((item) => {
          // 一级科目
          if (options.type === 1) {
            let _subject = {
              value: item.id,
              label: item.dictDesc,
              children: [],
              dictValue: item.dictValue
            }
            this.subjectData = [...this.subjectData, _subject]
          }else if (options.type === 2 && this.subjectData && this.subjectData.length) {
            // 二级科目
            this.subjectData.map(ele =>{
              if (item.parentId == ele.value) {
                let _subject2 = {
                  value: item.id,
                  label: item.dictDesc,
                  dictValue: item.dictValue
                }
                ele.children = [...ele.children, _subject2]
              }
            })
          }
        })
      }
      // 请求二级科目时的回调
      options.type === 1 ? options.callback && options.callback() : ''
    },
     // 一级科目
    async getAllProject(){
      this.getProject({
        params:{
          groupId: 31 // 传31查询一级科目
        },
        type:1,
        callback:()=>{
          this.getProject({
          params: {
            groupId: 32 // 传32查询二级科目
          },
          type: 2
          })
        }
      })
    },
    // 支付方式
    async getPayStyle(){
      this.getProject({
        params: {
          groupId: 1 // 传32查询二级科目
        },
        type: 3
      })
    },
    // 导出
    exportReport(){
      // if ( !Utils.hasPermission( 'outConsumptions_settlementMonthDetailExport' ) ) {
      //   this.$Notice.error( {
      //     title: "无权限操作"
      //   } );
      //   return
      // }
      if (!this.accountList.length) {
        this.$Notice.warning( {
          title: "无数据符合当前筛选条件，请调整"
        } );
        return
      }
      let params = {
        pageNum:this.query.page,
        pageSize:this.query.pageSize,
        settleDate:this.settleDate,
        owner:this.owner.split('_')[1],
        roomId:this.roomId,
        accountDateStart:this.manageTime[0] ? Moment( this.manageTime[0] ).format( 'YYYY-MM-DD' ):'',
        accountDateEnd:this.manageTime[1] ? Moment( this.manageTime[1] ).format( 'YYYY-MM-DD' ):'',
        subjectId:this.query.subjectOne,
        sonSubjectId:this.query.subjectTwo,
        payTypes:this.query.payType.toString(),
        orderSourceIds:this.query.orderSource.toString(),
        otherNo:this.query.orderOTA,
        orderNo:this.query.orderNO,
        cleanNo:this.query.jobNO,
      }
      const initParam = params => {
				let paramStr = '';
				Object.keys( params ).forEach( item => {
					if ( params[item] ) {
						paramStr += item + '=' + params[item] + '&';
					}
				} )
				return paramStr.substring( 0, paramStr.lastIndexOf( '&' ) );
			}
      let paramsInfos = initParam( params );
			let url = `${ Config[this.env].accountUrl }outConsumptions/settlementMonthDetailExport?${ paramsInfos }`;
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, "" )
    },
    preventSubmit(){
      return false;
    }
  },
}
</script>

<style lang="scss" scoped>
.selt-p{
  .selt-col {
    background: #f5f5f5;
    padding: 15px 0;
  }
  p{
    text-align: center;
    line-height: 28px;
    margin: 0;
  }
}
.tableData{
  width: 480px;
  border: 1px solid #ddd;
  margin: 0 auto;
  text-align: center;
  tr:nth-child(2n+1){
    background: #eee;
  }
  tr{
    line-height: 44px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/report/bill-statement/monthlySettleDetail.vue